type PropagationEvent = {
  stopPropagation: () => void;
};

type TriggerEvent = PropagationEvent & {
  preventDefault: () => void;
};

export const stopCollectionMenuClickPropagation = (event: PropagationEvent) => {
  event.stopPropagation();
};

export const stopCollectionMenuTriggerEvent = (event: TriggerEvent) => {
  event.preventDefault();
  event.stopPropagation();
};
